import React, { useEffect } from 'react';
import Fieldset from '../fieldset';
import { DataStatus } from './appointment-state';
import { Notification } from './notification';
import { Loader } from './loader';
import { TimeSlotPicker } from './time-slot-picker';
import { formatAppointmentSubmission } from './actions/format-appointment-submission';
import { useTranslation } from '../../contexts/translation-context';
import { useSubmitSuccessEvent } from '../../contexts/events-context';
import { classes } from './appointment.st.css';
import { AppointmentContextProvider, useAppointmentContext } from './context/appointment-context';
export function AppointmentFieldWUT(props) {
  const {
    onFocus,
    onBlur,
    inputId,
    ariaLabelledBy,
    ariaDescribedBy,
    required
  } = props;
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    onFocus: onFocus,
    onBlur: onBlur,
    ariaLabelledBy: ariaLabelledBy,
    ariaDescribedBy: ariaDescribedBy,
    required: required
  }, /*#__PURE__*/React.createElement(AppointmentContextProvider, {
    appointmentFieldProps: props
  }, /*#__PURE__*/React.createElement(RenderField, null)));
}
const RenderField = () => {
  const {
    appointmentFieldProps,
    appointmentState,
    setAppointmentState
  } = useAppointmentContext();
  const {
    t
  } = useTranslation();
  const {
    onChange,
    value: selectedSlot,
    target,
    fieldId
  } = appointmentFieldProps;
  useSubmitSuccessEvent(values => {
    var _appointmentState$ava;
    const submittedSlot = values == null ? void 0 : values[target];
    if (appointmentState != null && (_appointmentState$ava = appointmentState.availabilitySlots) != null && _appointmentState$ava.length) {
      const availabilitySlots = appointmentState.availabilitySlots.filter(slot => {
        var _slot$slot;
        return (slot == null || (_slot$slot = slot.slot) == null ? void 0 : _slot$slot.startDate) !== (submittedSlot == null ? void 0 : submittedSlot.startDate);
      });
      setAppointmentState({
        availabilitySlots
      });
    }
  });
  useEffect(() => {
    if (onChange) {
      onChange(formatAppointmentSubmission(selectedSlot));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSlot == null ? void 0 : selectedSlot.startDate, selectedSlot == null ? void 0 : selectedSlot.endDate, appointmentState == null ? void 0 : appointmentState.timezone]);
  if (appointmentState != null && appointmentState.error) {
    console.error('Error in appointment state', appointmentState.error);
  }
  if (appointmentState != null && appointmentState.error) {
    return /*#__PURE__*/React.createElement(Notification, {
      message: t('form.appointment.empty-state.notification.text')
    });
  }
  if ((appointmentState == null ? void 0 : appointmentState.dataStatus) === DataStatus.LOADING) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.verticalCenterLoader
    }, /*#__PURE__*/React.createElement(Loader, null)), /*#__PURE__*/React.createElement(TimeSlotPicker, {
      visibility: "hidden"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(TimeSlotPicker, {
    fieldId: fieldId
  }));
};
//# sourceMappingURL=appointment.js.map